import React from 'react';

import { Avatar, TeamUserAvatar } from '@poseidon/components/Avatar';
import { Tooltip } from '@poseidon/components/Input2';

export interface UserIconsNImage {
  profilePicture: string | null;
  name: string | null;
  email: string;
}

interface UserIconsProps {
  totalUserCount: number,
  nImages: UserIconsNImage[];
}

export default function UserIcons({ totalUserCount, nImages }: UserIconsProps) {
  const remainingLength = totalUserCount - nImages.length;
  return (
    <div className="flex justify-end">
      {nImages.map((userImage, i) => (
        <Tooltip tooltip={userImage?.name ?? userImage.email} key={i}>
          <TeamUserAvatar
            className="-ml-1 size-6 ring-2 ring-white dark:ring-slate-800"
            userTeam={{
              userTeamName: userImage.name || undefined,
              profilePicture: userImage.profilePicture || undefined,
              userEmail: userImage.email,
            }}
            shape="circle"
          />
        </Tooltip>
      ))}
      {remainingLength > 0 && (
        <Avatar
          srcs={[]}
          alt={`+ ${remainingLength}`}
          className="-ml-1 size-6 ring-2 ring-white dark:ring-slate-800"
          coloredBackground
          shape="circle"
        />
      )}
    </div>
  );
}
